import React from 'react'
import { useTranslation } from 'react-i18next';
import { BASE_API } from '../Config/Config';

function RTI() {
  const { t } = useTranslation();

  return (
    <div className='wh-100'>
      <div
        className="container py-5"
      >
        <div className="container">

          {/* Page Title */}
          <h2
            className="mb-4 fw-bold text-primary"
          >
            {t('rtiTitle')}
          </h2>

          {/* Links Section */}
          <div className="list-group border-0">

            <a
              href={`${BASE_API}/images/RTI/RTIAct2005.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-center"
            >
              <span
                className="me-3 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#2f7ed8",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <i className="bi bi-play"></i>
              </span>
              {t('rtiLink1')}
            </a>

            <a
              href={`${BASE_API}/images/RTI/rtiactenglishandtamil.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-center"
            >
              <span
                className="me-3 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#2f7ed8",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <i className="bi bi-play"></i>
              </span>
              {t('rtiLink2')}
            </a>

            <a
              href={`${BASE_API}/images/RTI/RTISecondAppealFormat.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-center"
            >
              <span
                className="me-3 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#2f7ed8",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <i className="bi bi-play"></i>
              </span>
              {t('rtiLink3')}
            </a>

          </div>
        </div>
      </div>
    </div>
  )
}

export default RTI